import { MutationFunction, useQueryClient } from "react-query";
import { Response, useHTTP, useHTTPMutation } from "shared/lib/http";
import { useUserAuthState } from "src/features/auth/UserAuthState";
import { API_BASE_URL } from "src/lib/config";

export interface CheckoutExtensionsOptions {
	merchantId: string;
	requestModel: SetCheckoutExtensionsRequestModel;
}

export interface SetCheckoutExtensionsRequestModel {
	readonly isEnabled: boolean;
}

export const useSetMerchantCheckoutExtensions = () => {
	const queryClient = useQueryClient();
	const { state } = useUserAuthState();
	const http = useHTTP(state.accessToken);

	const mutFunc: MutationFunction<Response<undefined>, CheckoutExtensionsOptions> = (options: CheckoutExtensionsOptions) => {
		return http<undefined, SetCheckoutExtensionsRequestModel>({
			method: "POST",
			url: `${API_BASE_URL}/admin/merchant/${options.merchantId}/checkout-extensions`,
			body: options.requestModel
		});
	};

	return useHTTPMutation(mutFunc, {
		onSuccess: (_, options) => {
			queryClient.invalidateQueries(["merchant", options.merchantId]);
		}
	});
};
